import { useState } from "react";
import { IMinerPhotoProps } from "./MinerPhoto.props";
import Lightbox from "react-image-lightbox";
import styles from "./MinerPhoto.module.scss";

export default function MinerPhoto({ src, images }: IMinerPhotoProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentPos, setCurrentPos] = useState<number>(
    images.indexOf(src) || 0
  );
  const onOpenLightBox = () => setIsOpen(true);

  const onNext = () => setCurrentPos((currentPos + 1) % images.length);
  const onPrev = () =>
    setCurrentPos((currentPos + images.length - 1) % images.length);

  return (
    <>
      {isOpen && (
        <Lightbox
          mainSrc={images[currentPos]}
          onCloseRequest={() => setIsOpen(false)}
          nextSrc={images[(currentPos + 1) % images.length]}
          prevSrc={images[(currentPos + images.length - 1) % images.length]}
          onMovePrevRequest={onPrev}
          onMoveNextRequest={onNext}
        />
      )}
      <div className={styles.photo} onClick={onOpenLightBox}>
        <img src={src} alt={"miner image"} />
      </div>
    </>
  );
}
